import Vue from 'vue'
import _ from 'lodash'
import { processMaterials,assignAndSortMaterials } from '@/utils/alias'

const form_data = {
    id: 0,
    name: "",
    status: 0,
    sex: 0,
    parent_product_category_id: 0,
    child_product_category_id: 0,
    product_category_id: 0,
    description: "",
    image: "",
    image_list: [],
    pattern_type: 0,
    pattern_id: 0,
    consumption: 0,
    consumption2: 0,
    pattern: [],
    material: [],
    is_material_self: 0,
    material_self: [],
    is_material_daigou: 0,
    material_daigou: [],
    accessory: [],
    is_accessory_self: 0,
    accessory_self: [],
    is_accessory_daigou: 0,
    accessory_daigou: [],
    yinhua: [],
    xiuhua: [],
    special_tech: [],
    tech: [],
    trademark: [],
    label: [],
    package: [],
    other_remark: "",
    other_file: [],
    material_file: [],
    accessory_file: [],
    is_extra_making: 0,
    package_detail:[],
    is_multiple: 0,
    children: [],
    style_no_push: "",
}

const m = {
    namespaced: true,
    state() {
        return {
            height: '800px',
            is_lesson_show: false,
            product_category_list: [],
            form_data: _.cloneDeep(form_data),
            is_lesson_popup_show: false, // 控制浮窗显示
            is_pip: false,                // 控制画中画状态
            videoCurrentTime: 0 // 新增：保存视频当前播放时间
        }
    },
    getters: {},
    mutations: {
        show_lesson_popup(state) {
            state.is_lesson_popup_show = true;
        },
        hide_lesson_popup(state) {
            state.is_lesson_popup_show = false;
        },
        toggle_pip(state, value) {
            state.is_pip = value;
        },
        set_height(state, payload) {
            state.height = payload
        },
        show_lesson(state) {
            state.is_lesson_show = true
        },
        hide_lesson(state) {
            state.is_lesson_show = false
        },
        set_product_category_list(state, payload) {
            state.product_category_list = payload
        },
        clear(state) {
            state.form_data = _.cloneDeep(form_data)
        },
        init(state, payload) {
            state.form_data = payload.design
            state.form_data.from = ''
        },
        update_common(state, payload) {
            state.form_data[payload.key] = payload.value
        },
        clear_special_tech(state) {
            state.form_data.special_tech = []
        },
        update_special_tech(state, id) {
            let arr = state.form_data.special_tech
            if(!state.form_data.special_tech.includes(id)) {
                arr.push(id)
                state.form_data.special_tech = [...new Set(arr)]
            } else {
                state.form_data.special_tech = arr.filter(v => v != id)
            }
        },
        arr_push_one(state, payload) {
            const { key, value } = payload;
            if(key === 'material'){
                // 使用工具函数分配 alias 并排序
                const processedList = assignAndSortMaterials([
                    ...(_.cloneDeep(state.form_data.material)),
                ], value);
                // 平台面料ID是大于0
                state.form_data.material = processedList.filter(v=>v.id>0);
            }else{
                state.form_data[payload.key].push(payload.value);
            }
        },
        arr_update_one(state, payload) {
            const { key, index, value } = payload;
            state.form_data[payload.key].splice(payload.index, 1, payload.value);
            if(key === 'material'){
                // 整合平台和客供的所有面料集合，index为所有面料集合所在位置
                const processedList = processMaterials(JSON.stringify([
                    ...(_.cloneDeep(state.form_data.material)),
                ],null,2),(key === 'material') ? index : (state.form_data.material.length) + index);
                // 平台面料ID是大于0
                state.form_data.material = processedList.filter(v=>v.id>0);
            }
        },
        arr_remove_one(state, payload) {
            state.form_data[payload.key].splice(payload.index, 1);
        },
        update_video_current_time(state, time) {
            state.videoCurrentTime = time;
        },
        package_replace(state,payload){
            const {index,data,value} = payload;
            console.log('value',value);
            state.form_data.package_detail[index].is_original = data.is_original;
            const repeat_find = state.form_data.package_detail.findIndex((item)=>item.replace_id == state.form_data.package_detail[index].id);
            if(repeat_find != -1){
                state.form_data.package_detail = state.form_data.package_detail.filter((item)=>item.replace_id != state.form_data.package_detail[index].id);
            }
            state.form_data.package_detail.push(value);
        },
        delete_replace_package(state,payload){
            const {id,replace_id} = payload;
            const find_original = state.form_data.package_detail.findIndex(item=>item.id == replace_id);
            if(find_original != -1){
                state.form_data.package_detail[find_original].is_original = null;
            }
            state.form_data.package_detail = state.form_data.package_detail.filter(item=>item.id != id);
        }
    },
    actions: {}
};

export default m;
